import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Grid,
  styled,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableBody,
  Paper,
  Tooltip,
} from "@mui/material";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import MultiSelectField from "../CommonComponents/MultiSelectField";
import CustomButton from "../CommonComponents/Button";
import { CompanyAndUsersData } from "../../actions/CompanyAndUsers";
import { UserIdApprover } from "../../actions/Approver";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import CompnayModal from "./CompnayModal";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CompanyUpdateModal from "./CompanyUpdateModal";
import TopViewNav from "../CommonComponents/TopViewNav";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { companyWiseEmp } from "../../actions/Companywiseclient";

const TopHeading = styled(Typography)({
  fontSize: "25px",
  fontWeight: "bold",
  color: "#2A3478",
  marginTop: "20px",
  marginBottom: "20px",
});

let selectedArray = [];

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const CompanyPermissions = () => {
  //   const [personName, setPersonName] = React.useState([]);
  //   const handleChange = (event) => {
  //     const {
  //       target: { value },
  //     } = event;
  //     setPersonName(typeof value === "string" ? value.split(",") : value);
  //   };
  const [companyData, setCompanyData] = useState();
  const [isEditable, setIsEditable] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteId, setSiteId] = useState();

  const [approverlist, setApproverlist] = useState([]);
  const [companyUsers, setCompanyUsers] = useState([]);
  console.log("companyUsers: ", companyUsers);
  const [companyId, setCompanyId] = useState();
  const [companyUsersCopy, setCompanyUsersCopy] = useState([]);
  const [approveUserId, setApproveUserId] = useState(null);
  const [oldUsers, setOldUsers] = useState([]);
  console.log("oldUsers: ", oldUsers);
  const [companyUseId, setcompanyUseId] = useState([]);
  console.log("companyUseId: ", companyUseId);
  const [ParmissonList, setPremissionList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalUpdate, setOpenModalUpdate] = useState(false);
  const [selectedApprover, setSelectedApprover] = useState([]);

  const [updateData, setUpdateData] = useState([]);
  const [userId, setUserId] = useState({});
  const [companyUpdateId, setCompanyUpadteId] = useState({});
  const [AprroverUpdateId, setAprroverUpdateId] = useState();
  const [rowData, setRowData] = useState({});
  const navigate = useNavigate();

  console.log(selectedApprover, "companyIddfff");

  const selectAllOption = { id: "selectAll", name: "Select All", empCode: "" };
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const fetchCompanyList = async () => {
    const res = await CompanyAndUsersData.fetchCompanyAndUserList();
    if (res !== null) {
      setCompanyData(res.data);
    } else {
      setCompanyData([]);
    }
  };

  let oldusr = [];
  //   let companyUseId = []
  const companyListHandle = (value) => {
    oldusr = [];
    if (value !== null) {
      setCompanyId(value);
      setCompanyUsers(value.userDtoList);
      setOldUsers([]);
    } else {
      setCompanyUsers([]);
      setCompanyId("");
    }
  };
  //   debugger
  let uId = [];
  const companyUserListHandle = (value) => {
    console.log("value: ", value);
    if (value?.some((val) => val?.id === "selectAll")) {
      console.log(value, "hdvwhdew");
      // const filteredCompanyUsers = companyUsers?.filter(
      //   (user) => !user?.isApproverSet
      // );

      if (
        Boolean(companyUseId?.length > 0) &&
        Boolean(companyUseId?.length === companyUsers?.length)
      ) {
        oldusr = [];
        setcompanyUseId([]);
        setOldUsers(companyUsers);
      } else {
        // const filteredCompanyUsersIsApproverSetTrue = companyUsers?.filter(
        //   (user) => user?.isApproverSet
        // );
        // oldusr = filteredCompanyUsersIsApproverSetTrue;
        oldusr = [];
        console.log("oldusr: ", oldusr);

        // setOldUsers(filteredCompanyUsersIsApproverSetTrue);
        setOldUsers([]);
        // for (let i = 0; i < value.length; i++) {
        //   uId.push(value[i].id);
        // }
        companyUsers?.map((item) => {
          uId.push(item?.id);
        });
        console.log(uId);
        setcompanyUseId(uId);
      }
    } else {
      console.log(value, "hdvwhdew");
      oldusr.push(value);
      console.log("oldusr: ", oldusr);
      // if (value !== null) {

      // }
      // else {

      // }
      //   console.log(value);
      const uniqueOnject = companyUsers.filter(
        ({ id: id1 }) => !value.some(({ id: id2 }) => id1 === id2)
      );
      setOldUsers(uniqueOnject);
      for (let i = 0; i < value.length; i++) {
        uId.push(value[i].id);
      }
      console.log(uId);
      setcompanyUseId(uId);
      //   console.log(uniqueOnject);
      // for (let i = 0; i < value.length; i++) {
      //   const element = value[i];
      //     // companyUsers.map(data=>{
      //     //     if (element.id === data.id) {
      //     //         oldusr = []
      //     //         // setuId(data.id)
      //     //         console.log(data);
      //     //         uId.push(data.id);
      //     //         setcompanyUseId(uId);
      //     //         console.log(companyUseId);
      //     //     }else{
      //     //         oldusr.push(data)
      //     //         setOldUsers(oldusr);
      //     //         // companyUseId=[];
      //     //     }
      //     // })
      // }
    }
  };

  const siteListHandle = (value) => {
    if (value) {
      setCompanyUsers(
        (Array.isArray(companyId?.userDtoList)
          ? companyId?.userDtoList
          : []
        )?.filter((item) => item?.siteId === value?.id)
      );
      setOldUsers([]);
      setSiteId(value);
    } else {
      setCompanyUsers(
        Array.isArray(companyId?.userDtoList) ? companyId?.userDtoList : []
      );
      setOldUsers([]);
      setSiteId(null);
    }
  };
  const fetchCompanyWiseSiteList = async () => {
    const data = {
      companyId: companyId ? companyId.id : null,
      hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
    };
    const res = await companyWiseEmp.getAllCompanyWiseSite(data);
    if (res !== null) {
      console.log(res);
      setSiteList(res.data);
    } else {
      setSiteList([]);
    }
  };

  //   console.log(companyUseId);
  const approveUserHandle = (value) => {
    if (value !== null) {
      setApproveUserId(value.id);
    } else {
      setApproveUserId("");
    }
  };

  const fetchUserApprover = async () => {
    //alert(companyId)
    if (companyId == undefined || companyId == "") {
      alert("plz Select company Name ");
      return false;
    } else if (companyId?.isSiteConfigEnabled && !siteId?.id) {
      alert("plz Select Site ");
      return false;
    } else if (companyUseId == "") {
      alert("plz Select CompanyUser Name ");
      return false;
    } else if (approveUserId == null) {
      alert("plz Select approver Name ");
      return false;
    }
    let ids = JSON.parse(localStorage.getItem("data")).id;
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;

    const payload = {
      hrmsCompanyId: companyId ? companyId.id : null,
      createdBy: ids,
      userIds: companyUseId,
      approverId: approveUserId,
      companyName: companyId ? companyId.companyName : null,
    };
    const res = await UserIdApprover.fetchApprover(payload);
    if (res !== null && res?.status === 200) {
      // console.log("somya res: ", res);
      // setCompanyData(res.data);
      setCompanyData(res?.data?.data);

      alert("Permission is approved!!!");
      window.location.reload(true);
      //navigate("/dashboard");
      setOpenModal(false);
    } else {
      // console.log("somya res: ", res);
      const parsedErrMessage =
        res?.response?.data?.responseDescription ||
        res?.message ||
        "Something Went Wrong";
      alert(parsedErrMessage);
      // setCompanyData([]);
      // window.location.reload(true);
    }

    // setOpenModal(false);
  };
  const fetchApproverList = async () => {
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    let data = {
      hrmsCompanyId: companyId ? companyId.id : null,
      userIds: companyUseId,
      approverId: approveUserId,
    };

    const res = await UserIdApprover.fetchApproverList(data);
    if (res !== null) {
      console.log(res);
      setApproverlist(res.data);
    } else {
      setApproverlist([]);
    }
  };
  const fetchMultiLevelApproverListForCompanyDetails = async () => {
    if (companyId?.isSiteConfigEnabled && !siteId) {
      return alert("Please Select Site!");
    }
    let hrmsCompanyId = JSON.parse(localStorage.getItem("data")).hrmsCompanyId;
    let data = {
      hrmsCompanyId: companyId ? companyId.id : null,
      userIds: companyUseId,
      approverId: approveUserId,
      siteId: siteId?.id || null,
    };

    const res = await UserIdApprover.fetchMultiLevelApproverList(data);
    if (res !== null) {
      console.log(res);

      console.log("multi level approver list: ", res);
      setApproverlist(res.data);
    } else {
      setApproverlist([]);
    }
  };

  const updateuserHandler = (data) => {
    console.log(data, "dwdwedetf");
    const approverDataByCompanyID = companyData?.filter((ele) => {
      return data.hrmsCompanyId == ele.id;
    });
    // let array =
    //   (Array.isArray(approverDataByCompanyID) &&
    //     approverDataByCompanyID[0]?.userDtoList) ||
    //   [];

    let array = [];

    if (
      Array.isArray(approverDataByCompanyID) &&
      approverDataByCompanyID.length > 0
    ) {
      const item = approverDataByCompanyID[0];
      const list = item?.userDtoList || [];

      if (item?.isSiteConfigEnabled) {
        array = list.filter((u) => u?.siteId === data?.user?.siteId);
      } else {
        array = list;
      }
    }

    console.log(approverDataByCompanyID, "approverDataByCompanyID");

    const uniqueOnject =
      array &&
      array.filter(
        ({ id: id1 }) => ![data.user].some(({ id: id2 }) => id1 === id2)
      );
    console.log(uniqueOnject, "uniqueOnjectedge");
    console.log(data, approverDataByCompanyID, "dgdd");
    setSelectedApprover(uniqueOnject);
    setUserId(data.user.name);
    setCompanyUpadteId(data.createdByUser.companyName);
    setUserId(data.user.name + `(${data.user.empCode})`);
    setUpdateData(data);
    setOpenModalUpdate(true);
  };
  const openModalHandler = () => {
    setOpenModal(true);
  };

  const updateUserHandler = () => {
    if (AprroverUpdateId == undefined || AprroverUpdateId == "") {
      alert("plz Select Aprrover Name ");
      return false;
    }
    const data = {
      id: updateData.id,
      updatedApproverId: AprroverUpdateId ? AprroverUpdateId.id : null,
    };
    UserIdApprover.deletArroved(data).then((res) => {
      if (res !== null && res?.status === 200) {
        // fetchApproverList();
        fetchMultiLevelApproverListForCompanyDetails();
        alert("Approver  Update Successfully");
        setOpenModalUpdate(false);
        window.location.reload(true);
      } else {
        // console.log("somya res: ", res);
        const parsedErrMessage =
          res?.response?.data?.responseDescription ||
          res?.message ||
          "Something Went Wrong";
        alert(parsedErrMessage);
      }
    });
    // setOpenModalUpdate(false);
  };
  const updateHandler = () => {
    if (companyId === undefined || companyId === "") {
      alert("plz Select company Name ");
      return false;
    }
    const data = {
      companyId: companyId ? companyId.id : null,
      hrmsUserIds: [],
    };

    CompanyAndUsersData.fetchCompanyUpdateByID(data).then((response) => {
      if (response !== null) {
        alert("Update Successfully!!");
      }
    });
  };
  const deleteHandler = () => {
    const data = {
      id: updateData.id,
      userId: updateData?.user?.id || null,
      // updatedApproverId:AprroverUpdateId?AprroverUpdateId.id:null,
    };
    UserIdApprover.deletArroved(data).then((res) => {
      if (res !== null && res?.status === 200) {
        // fetchApproverList();
        fetchMultiLevelApproverListForCompanyDetails();
        alert("Approver Delete Successfully");
        setOpenModalUpdate(false);
        window.location.reload(true);
      } else {
        // console.log("somya res: ", res);
        const parsedErrMessage =
          res?.response?.data?.responseDescription ||
          res?.message ||
          "Something Went Wrong";
        alert(parsedErrMessage);
      }
    });
    // setOpenModalUpdate(false);
  };

  const topViewNavData = React.useMemo(
    () => ({
      title: "Company Permission",
      backPath: "Company/Emp wise Configuration",
      backPathRoute: "/companywiseclient",
    }),
    []
  );

  useEffect(() => {
    fetchCompanyList();
    // fetchApproverList();
    fetchMultiLevelApproverListForCompanyDetails();
  }, []);

  useEffect(() => {
    if (companyId?.id) {
      fetchCompanyWiseSiteList();
    } else {
      setSiteList([]);
    }
    setSiteId(null);
  }, [companyId]);

  return (
    <main className="contents__root expense_list">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          {/* <TopHeading variant="h6">Company Permission</TopHeading> */}
          <Box
            sx={{
              marginBottom: 1.5,
            }}
          >
            <TopViewNav topViewNavData={topViewNavData} />
          </Box>
        </Grid>
        <CompnayModal
          title="Add Company Permisson"
          companyData={companyData}
          companyListHandle={companyListHandle}
          companyUsers={companyUsers}
          companyUserListHandle={companyUserListHandle}
          oldUsers={oldUsers}
          approveUserHandle={approveUserHandle}
          openModal={openModal}
          setOpenModal={setOpenModal}
          fetchUserApprover={fetchUserApprover}
          companyId={companyId}
          userId={userId}
          companyUseId={companyUseId}
          siteId={siteId}
          siteList={siteList}
          siteListHandle={siteListHandle}
        />

        <CompanyUpdateModal
          title="Update Company Permisson"
          companyData={companyData}
          companyListHandle={companyListHandle}
          companyUsers={companyUsers}
          companyUserListHandle={companyUserListHandle}
          updateData={updateData}
          oldUsers={oldUsers}
          approveUserHandle={approveUserHandle}
          openModal={openModalUpdate}
          setOpenModal={setOpenModalUpdate}
          fetchUserApprover={fetchUserApprover}
          companyUpdateId={companyUpdateId}
          setCompanyUpadteId={setCompanyUpadteId}
          userId={userId}
          AprroverUpdateId={AprroverUpdateId}
          setAprroverUpdateId={setAprroverUpdateId}
          setUserId={setUserId}
          selectedApprover={selectedApprover}
          setSelectedApprover={setSelectedApprover}
          updateUserHandler={updateUserHandler}
          deleteHandler={deleteHandler}
          companyId={companyId}
          siteId={siteId}
          siteList={siteList}
          siteListHandle={siteListHandle}
        />
      </Grid>
      <Grid
        container
        spacing={1}
        direction="row"
        flexDirection="row"
        justifyContent="flex-start"
      >
        <Grid item xs={companyId?.isSiteConfigEnabled ? 2.25 : 3}>
          <CustomAutoComplete
            disablePortal
            id="company"
            options={(companyData !== undefined && companyData) || []}
            getOptionLabel={(option) => option.companyName}
            sx={{ width: "auto" }}
            onChange={(value, newVal) => companyListHandle(newVal)}
            renderInput={(params) => <TextField {...params} label="Company" />}
            size="small"
          />
        </Grid>
        {companyId?.isSiteConfigEnabled ? (
          <Grid item xs={companyId?.isSiteConfigEnabled ? 2.25 : 3}>
            <CustomAutoComplete
              disablePortal
              id="company"
              value={siteId || null}
              options={(siteList !== undefined && siteList) || []}
              getOptionLabel={(option) => option.name}
              sx={{ width: "auto" }}
              onChange={(event, newValue) => siteListHandle(newValue)}
              renderInput={(params) => <TextField {...params} label="Site" />}
              size="small"
            />
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={companyId?.isSiteConfigEnabled ? 2.25 : 3}>
          <CustomAutoComplete
            disablePortal
            disableCloseOnSelect
            limitTags={3}
            id="user"
            disabled={companyUsers && companyUsers.length > 0 ? false : true}
            multiple
            // options={companyUsers && companyUsers === [] ? [] : companyUsers}
            options={
              Array.isArray(companyUsers) && Boolean(companyUsers?.length)
                ? // ? companyUsers
                  [selectAllOption, ...companyUsers]
                : []
            }
            // getOptionDisabled={(option) => option?.isApproverSet === true}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              // const filteredCompanyUsers = companyUsers?.filter(
              //   (user) => !user?.isApproverSet
              // );
              const isSelectAll = option?.empCode === "";
              const isAllSelected =
                Boolean(companyUseId?.length > 0) &&
                Boolean(companyUseId?.length === companyUsers?.length);
              if (Boolean(option?.empCode === "")) {
                return (
                  <li key={key} {...optionProps}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={isSelectAll ? isAllSelected : selected}
                    />
                    {Boolean(option?.empCode === "")
                      ? `${option?.name}`
                      : `${option?.name} (${option?.empCode})`}
                  </li>
                );
              }
              return (
                <li key={key} {...optionProps}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {Boolean(option?.empCode === "")
                    ? `${option?.name}`
                    : `${option?.name} (${option?.empCode})`}
                </li>
              );
            }}
            value={companyUsers.filter((item) =>
              companyUseId.includes(item?.id)
            )}
            onChange={(value, newVal) => companyUserListHandle(newVal)}
            getOptionLabel={({ name, empCode, id }) => {
              if (Boolean(empCode === "")) {
                return `${name}`;
              }
              return `${name} (${empCode})`;
            }}
            sx={{ width: "auto" }}
            renderInput={(params) => (
              <TextField {...params} label="Company Users" />
            )}
            size="small"
          />
          {/* <MultiSelectField sx={{ width: "100%" }} size="small">
            <InputLabel id="demo-multiple-checkbox-label">User</InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              value={personName}
              onChange={handleChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {names.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox checked={personName.indexOf(name) > -1} />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </MultiSelectField> */}
        </Grid>
        <Grid item xs={companyId?.isSiteConfigEnabled ? 2.25 : 3}>
          <CustomAutoComplete
            disablePortal
            id="user"
            disabled={oldUsers && oldUsers.length > 0 ? false : true}
            options={oldUsers && oldUsers.length === 0 ? [] : oldUsers}
            // getOptionLabel={(option) => option.name}
            getOptionLabel={({ name, empCode }) => {
              return `${name} (${empCode})`;
            }}
            onChange={(value, newVal) => approveUserHandle(newVal)}
            sx={{ width: "auto" }}
            renderInput={(params) => <TextField {...params} label="Approver" />}
            size="small"
          />
        </Grid>
        <Grid item xs={1} textAlign="center">
          <CustomButton
            name={"Submit"}
            // onClick={fetchApproverList}
            onClick={fetchMultiLevelApproverListForCompanyDetails}
          />
        </Grid>
        <Grid item xs={1} textAlign="center">
          <CustomButton name={"Add"} onClick={openModalHandler}></CustomButton>
        </Grid>
        <Grid item xs={1} textAlign="center">
          <CustomButton name={"Update "} onClick={updateHandler}></CustomButton>
        </Grid>
      </Grid>

      <Grid sx={{ marginTop: "10px" }}>
        <TableContainer
          component={Paper}
          sx={{
            height: "calc(100vh - 217px)",
            "&::-webkit-scrollbar": {
              width: "0px",
            },
          }}
        >
          <Table size="small" id="FlowUpTable">
            <TableHead>
              <TableRow
                style={{
                  backgroundColor: "rgb(32 80 130)",
                  color: "#fff",
                }}
                key={1}
              >
                <TableCell style={{ color: "#fff" }} align="center">
                  S.No
                </TableCell>
                <TableCell style={{ color: "#fff" }} align="center">
                  Created By
                </TableCell>
                <TableCell style={{ color: "#fff" }} align="center">
                  Company Name
                </TableCell>
                <TableCell style={{ color: "#fff" }} align="center">
                  User Name
                </TableCell>
                <TableCell style={{ color: "#fff" }}>Approver Name</TableCell>
                {/* <TableCell style={{ color: "#fff" }} align="center">
                  Create Date
                </TableCell> */}
              </TableRow>
            </TableHead>
            {approverlist &&
              approverlist.length > 0 &&
              approverlist.map((val, ind) => {
                console.log(val, "dkjfgeuyfueyrf");
                return (
                  <>
                    <TableBody>
                      <TableCell align="center">
                        {val.communicationId !== null ? `${ind + 1}` : ind + 1}
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{
                          minWidth: "160px",
                        }}
                      >
                        {val && val.createdByUser && val.createdByUser.name
                          ? val.createdByUser.name
                          : "NA"}
                        {`${
                          val.createdByUser.empCode
                            ? `(${val.createdByUser.empCode})`
                            : ""
                        }`}
                      </TableCell>
                      <TableCell align="center">
                        {/* {val &&
                        val.createdByUser &&
                        val.createdByUser.companyName
                          ? val.createdByUser.companyName
                          : "NA"} */}
                        {val && val.companyName ? val.companyName : "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {val && val.user && val.user.name
                          ? val.user.name
                          : "NA"}
                        {`${val.user.empCode ? `(${val.user.empCode})` : ""}`}
                      </TableCell>
                      {Boolean(val?.isMultiLevelApproverEnabled) ? (
                        <>
                          <TableCell align="center">
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {val?.approverList?.length > 0 &&
                                (() => {
                                  const displayedApprovers =
                                    val.approverList.slice(0, 1);
                                  const remainingCount =
                                    val.approverList.length -
                                    displayedApprovers.length;

                                  return (
                                    <>
                                      {displayedApprovers.map(
                                        (approver, index) => (
                                          <span
                                            key={index}
                                            style={{ marginRight: "8px" }}
                                          >
                                            {approver?.approverId?.name}
                                            {approver?.approverId?.empCode
                                              ? ` (${approver?.approverId?.empCode})`
                                              : ""}
                                          </span>
                                        )
                                      )}
                                      {remainingCount > 0 && (
                                        <Tooltip
                                          arrow
                                          title={val.approverList
                                            .slice(1)
                                            .map(
                                              (item) =>
                                                `${
                                                  item?.approverId?.name || "NA"
                                                } (${
                                                  item?.approverId?.empCode ||
                                                  ""
                                                })`
                                            )
                                            .join(", ")}
                                          PopperProps={{
                                            modifiers: [
                                              {
                                                name: "offset",
                                                options: {
                                                  offset: [0, -6],
                                                },
                                              },
                                            ],
                                          }}
                                        >
                                          <span
                                            style={{
                                              cursor: "default",
                                              marginLeft: "8px",
                                              background: "#cbcbcb",
                                              lineHeight: 1.7,
                                              borderRadius: "5px",
                                            }}
                                          >
                                            &nbsp; +{remainingCount} more &nbsp;
                                          </span>
                                        </Tooltip>
                                      )}
                                    </>
                                  );
                                })()}

                              {/* Edit Icon */}
                              <EditIcon
                                sx={{
                                  color: "green",
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => updateuserHandler(val)}
                              />
                            </span>
                          </TableCell>
                        </>
                      ) : (
                        <TableCell align="center">
                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {val && val.approver && val.approver.name
                              ? val.approver.name
                              : "NA"}
                            {`${
                              val.approver.empCode
                                ? `(${val.approver.empCode})`
                                : ""
                            }`}
                            <EditIcon
                              sx={{
                                color: "green",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => updateuserHandler(val)}
                            />
                          </span>
                        </TableCell>
                      )}
                    </TableBody>
                  </>
                );
              })}
          </Table>
        </TableContainer>
      </Grid>
    </main>
  );
};

export default CompanyPermissions;
